import React from "react";
import { AppBar, Typography, Toolbar, Button, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/img/Gensparc_logo.webp";
import { Dashboard, Home, AdminPanelSettings, Work, Person, Logout,} from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn"; 
import TaskIcon from '@mui/icons-material/Task';
import BrowseGalleryIcon from '@mui/icons-material/BrowseGallery';

const Navbar = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login"; // Check if on login page

  if (isLoginPage) return null; // Hide Navbar on login page

  const isActive = (path) => location.pathname === path;

  return (
    <Box>
      {/* Horizontal Navbar */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#0c5273",
          color: "text.primary",
          height: "64px",
          width: "100%",
          zIndex: 1200,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingX: "16px",
            flexWrap: "wrap",
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center", padding: "0px" }}>
            <img
              src={logo}
              alt="Gensparc Logo"
              style={{
                width: "140px",
                height: "60px",
                marginLeft: "-25px",
              }}
            />
          </Box>

          {/* Buttons Section */}
          <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {/* <Button
              sx={{
                color: isActive("/profile") ? "#0c5273" : "#ffffff",
                backgroundColor: isActive("/profile")
                  ? "rgba(255, 255, 255, 0.8)"
                  : "transparent",
                "&:hover": {
                  backgroundColor: isActive("/profile")
                    ? "rgba(255, 255, 255, 0.8)"
                    : "rgba(255, 255, 255, 0.2)",
                },
              }}
              component={Link}
              to="/profile"
            >
              Profile
            </Button>

            <Button
              sx={{
                color: isActive("/settings") ? "#0c5273" : "#ffffff",
                backgroundColor: isActive("/settings")
                  ? "rgba(255, 255, 255, 0.8)"
                  : "transparent",
                "&:hover": {
                  backgroundColor: isActive("/settings")
                    ? "rgba(255, 255, 255, 0.8)"
                    : "rgba(255, 255, 255, 0.2)",
                },
              }}
              component={Link}
              to="/settings"
            >
              Settings
            </Button> */}

            <Button
              sx={{
                color: isActive("/logout") ? "#0c5273" : "#ffffff",
                backgroundColor: isActive("/logout")
                  ? "rgba(255, 255, 255, 0.8)"
                  : "transparent",
                "&:hover": {
                  backgroundColor: isActive("/logout")
                    ? "rgba(255, 255, 255, 0.8)"
                    : "rgba(255, 255, 255, 0.2)",
                },
              }}
              component={Link}
              to="/logout"
            >
              <Logout sx={{ fontSize: 24 }} />
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Sidebar Navbar */}
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          marginTop: "64px",
        }}
      >
        <AppBar
          position="fixed"
          sx={{
            width: { xs: "60px", sm: "72px" },
            backgroundColor: "white",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            zIndex: 1100,
            top: "64px",
            left: 0,
            paddingTop: "0px",
            paddingBottom: "16px",
          }}
        >
          {[
            { path: "/dashboard", icon: <Dashboard />, label: "Dashboard" },
            { path: "/employees", icon: <Person />, label: "Employee" },
            { path: "/work-location", icon: <LocationOnIcon />, label: "Work Locatioin" },
            { path: "/task-page", icon: <TaskIcon />, label: "Task" },
            { path: "/leave-management", icon: <Work />, label: "Leave" },
            { path: "/shift-page", icon: <BrowseGalleryIcon />, label: "Shift" },
            // { path: "/attendance", icon: <Home />, label: "Attendance" },
            // { path: "/admin-dashboard", icon: <AdminPanelSettings />, label: "Admin" },
            
          ].map(({ path, icon, label }) => (
            <Button
              key={path}
              color="inherit"
              component={Link}
              to={path}
              startIcon={icon}
              sx={{
                justifyContent: "center",
                textAlign: "center",
                width: "100%",
                flexDirection: "column",
                fontSize: "9px",
                fontWeight: "600",
                padding: "10px 10px 0px 10px",
                backgroundColor: isActive(path) ? "#0c5273" : "transparent",
                color: isActive(path) ? "white" : "black",
                "&:hover": {
                  backgroundColor: isActive(path)
                    ? "#0c5273"
                    : "rgba(255, 255, 255, 0.2)",
                },
                "& .MuiSvgIcon-root": {
                  color: isActive(path) ? "white" : "black",
                },
              }}
            >
              {label}
            </Button>
          ))}
        </AppBar>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            padding: "16px",
            marginLeft: { xs: "60px", sm: "72px" },
            overflowY: "auto", // Allow vertical scroll for content if needed
          }}
        >
          <Typography variant="h4"></Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Navbar;
